import {get, post} from '@/services/infrastructure/api.service'
import {SubAccount} from '@/subaccount/types/SubAccount'
import {Product} from '@/products/product.types'

const ROOT_PATH = '/dummy-generator'
const USERS_PATH = 'users'
const CUSTOMERS_PATH = 'customers'
const SUPPLIERS_PATH = 'suppliers'
const PRODUCTS_PATH = 'products'
const TRANSACTIONS = 'transactions'

export const getRandomUsers = async(count: Number) => {
    const path = `${ROOT_PATH}/${USERS_PATH}`
    return await get(path, { count })
}

export const generateTransactions = async(count: Number) => {
    const path = `${ROOT_PATH}/${TRANSACTIONS}`
    await post(path, { count })
}

export const generateAssignments = async(count: Number) => post(`${ROOT_PATH}/assignments?count=${count}`, {})

export const generateCustomers = async (count: Number) => {
    const path = `${ROOT_PATH}/${CUSTOMERS_PATH}`
    const response = await post(path, {count})
    return response as SubAccount[]
}

export const generateSuppliers = async (count: Number) => {
    const path = `${ROOT_PATH}/${SUPPLIERS_PATH}`
    const response = await post(path, {count})
    return response as SubAccount[]
}

export const generateProducts = async (count: Number) => {
    const path = `${ROOT_PATH}/${PRODUCTS_PATH}`
    const response = await post(path, {count})
    return response as Product[]
}